export default "__VITE_ASSET__7c878332__"